module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-default margin-bottom-0px"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Mapping List")]), _vm._v(" "), _c('div', {
    staticClass: "action-button pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.OpenPOP()
      }
    }
  }, [_vm._v("Add Mapping")])]), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "Modal"
    }
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "height": "400PX",
      "max-width": "600px"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Select Journey")])]
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_c('form', {
      staticClass: "form-horizontal",
      attrs: {
        "action": "#",
        "method": "post"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.addNewMapping.apply(null, arguments)
        }
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label",
      staticStyle: {
        "font-weight": "500"
      },
      attrs: {
        "for": "campaign"
      }
    }, [_vm._v("Journey Name")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8"
    }, [_c('treeselect', {
      attrs: {
        "placeholder": "--Choose a Journey--",
        "multiple": false,
        "options": _vm.conversationList
      },
      model: {
        value: (_vm.journey_id),
        callback: function($$v) {
          _vm.journey_id = $$v
        },
        expression: "journey_id"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "form-group pull-right"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.close
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit",
        "value": "Submit"
      }
    })])])])]
  })], 2)], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-footer"
  })])]) : _vm._e()]), _vm._v(" "), (_vm.actionInProgress) ? _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/loader/nivi-loader.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-footer no-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-good-table', {
    attrs: {
      "mode": "remote",
      "styleClass": "vgt-table good-table condensed striped",
      "columns": _vm.columns,
      "rows": _vm.mappingData,
      "totalRows": _vm.mappingCount,
      "pagination-options": {
        enabled: true,
        perPage: 20
      }
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_vm._t("default", null, {
          "props": props
        }), _vm._v(" "), (props.column.field == 'created_at') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')) + "\n                      ")]) : (props.column.field == 'edit') ? _c('span', [_c('router-link', {
          attrs: {
            "to": ("scout_jor_detail?mappingId=" + (props.row.id) + "&&journey_name=" + (props.row.journey))
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1) : (props.column.field == 'delete') ? _c('span', [_c('i', {
          staticClass: "fa fa-times-circle",
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.showDeleteConfirmationPopup(props.index)
            }
          }
        })]) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, true)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('nv-empty-state', {
    attrs: {
      "icon": "fa-list",
      "title": "No Scout-JOR mappings found",
      "hint": "Try changing the filters."
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "loadingContent"
  })], 2)], 1)])])])])])]), _vm._v(" "), (_vm.isDeleteConfirmationVisible) ? _c('deleteConfirmationModal', {
    attrs: {
      "isDeleteConfirmationVisible": _vm.isDeleteConfirmationVisible,
      "confirmationMessage": _vm.confirmationMessage,
      "actionToBePerformed": _vm.actionToBePerformed
    },
    on: {
      "close": _vm.closeConfirmationModal,
      "deleteScoutJORMapping": _vm.deleteScoutJORMapping
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Scout JOR Mapping\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v("Scout JOR Mappings")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Mapping List")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-847473b6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scout-JOR-mapping/scoutJORMappingList.vue
// module id = 7P5x
// module chunks = 1